import React, {useEffect, useRef} from 'react'
import {Dialog, Button} from '@startlibs/components'
import styled from 'styled-components'

const ErrorDialog = styled(Dialog) `
  max-width: 36rem;
`

export const DownloadErrorDialog = ({closeDialog, study}) => {
  return <ErrorDialog
    title="Your download failed"
    closeDialog={closeDialog}
    footer={<>
      <Button alert onClick={closeDialog}>Close</Button>
    </>}
  >
    <p>Please check your connection and try again.</p>
    <p className="additional-info">If error persists, please contact <a className="link" target="_blank" href="mailto:support@purview.net">support@purview.net</a>.</p>
  </ErrorDialog>
}